import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
const PayMethodMain = styled("div")(({ theme }) => ({
  width: "80%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.between("md", "lg")]: {
    width: "90%",
    margin: "0 auto",
  },
}));
const CardsMain = styled("div")(({ theme }) => ({
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#191D31",
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      paddingTop: "20px",
    },
  },
  "& .no_message_text": {
    fontSize: "15px",
    lineHeight: "25px",
    color: "#191D31",
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    marginTop: "10px",
    marginBottom: "10px",
  },
}));
const CardsMainWrap = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "5px",
  // justifyContent: "space-between",
  alignItems: "center",
  overflow: "auto",
  width: "auto",
  whiteSpace: "nowrap",
  scrollbarWidth: "thin",
  scrollbarColor: "#B4B4B4 transparent",
  "&::-webkit-scrollbar": {
    width: 2,
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 6,
    backgroundColor: "#B4B4B4",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "::-webkit-scrollbar:horizontal": {
    height: "8px",
    backgroundColor: "#B4B4B4",
  },
  "::-webkit-scrollbar-thumb:horizontal": {
    background: "#000",
    borderRadius: "10px",
  },

  "& .card_layout:first-of-type": {
    marginLeft: "0px",
  },
  // "& a": {
  //   width: "100%",
  //   textDecoration: "none",
  // },
  [theme.breakpoints.down("md")]: {
    overflow: "auto",
    "& a": {
      flex: "0 0 100%",
    },
  },
  "& .card_layout": {
    width: "50%",
    display: "inline-block",
    margin: "5px",
    marginTop: "0px",
    "& .css-1hcxvu3": {
      background: "#323232",
      marginTop: "10px",
      border: "none",
    },
    "& .css-jig3ky": { color: "#fff" },
    "& .css-1dpcftw": { color: "#fff" },
    "& .css-14ymhck": { color: "#fff" },
    "& .css-1ti503y .date span": { color: "#fff" },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  "& > a:last-child": {
    "& .css-1hcxvu3": {
      background: "#6B4B81",
    },
  },
}));

const AddNewCard = styled(Button)(({ theme }) => ({
  border: "none",
  background: "none",
  textTransform: "capitalize",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  textAlign: "center",
  color: "#0B0B0B",
  // paddingLeft: "0px",
  padding: "10px",
  fontFamily: theme.typography.fontFamily,
  "& svg": { marginRight: "10px" },
  marginTop: "5px",
}));

export { PayMethodMain, CardsMain, CardsMainWrap, AddNewCard };
